<div class="color-bar"></div>

    <div>
      <app-bi-spuie-lista [filtros]="filtros" (exibir)="selecionar($event)">
      </app-bi-spuie-lista>
    </div>